exports.connect = {
	url: "https://api.laroseraiedomaha.camp/"
}
